import React from 'react';
import "./FAQPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {faq_s} from "../../data";
import Accordion from "../../Common/Accordion"


function App() {
  return <X11FAQsPageMobile {...x11FAQsPageMobileData} />;
}

export default App;

function X11FAQsPageMobile(props) {
  const {
    place,
    overlapGroup,
    rectangle77,
    text117,
    text118,
    frame145Props,
    closeProps,
    frame15902Props,
    frame159022Props,
    frame159023Props,
    frame159024Props,
    frame159025Props,
    frame159026Props,
    //group2122Props,
  } = props;

  return (
    <div className="faqpm-container-center-horizontal">
      <div className="faqpm-x11-faq-s-page-mobile screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="faqpm-place faqpm-valign-text-middle faqpm-typographyheadlineh4-extrabold-24">{place}</h1>
        <div className="faqpm-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
          {/* <img className="faqpm-rectangle-77" src={rectangle77} /> */}
          <img className="faqpm-rectangle-77" src={faq_s.FAQsHeader} alt="Webuildd FAQs" />
        </div>
        {/* <div className="faqpm-frame-1653">
          <div className="faqpm-frame-1589 faqpm-border-1px-black-2">
            <div className="faqpm-frame-1591">
              <div className="faqpm-text-3 faqpm-valign-text-middle faqpm-overpass-bold-shark-16px">{text117}</div>
              <Close src={closeProps.src} />
            </div>
            <p className="faqpm-text-4 faqpm-typographybodysmall-12-regular">{text118}</p>
          </div>
          <Frame159022 text119={frame15902Props.text119} plusProps={frame15902Props.plusProps} />
          <Frame159022 text119={frame159022Props.text119} plusProps={frame159022Props.plusProps} />
          <Frame159022 text119={frame159023Props.text119} plusProps={frame159023Props.plusProps} />
          <Frame159022 text119={frame159024Props.text119} plusProps={frame159024Props.plusProps} />
          <Frame159022 text119={frame159025Props.text119} plusProps={frame159025Props.plusProps} />
          <Frame159022 text119={frame159026Props.text119} plusProps={frame159026Props.plusProps} />
        </div> */}
         <div className="faqpm-frame-1653">
        <Accordion/>
        </div>
        {/* <Group2122
          group862Props={group2122Props.group862Props}
          group872Props={group2122Props.group872Props}
          group322Props={group2122Props.group322Props}
          frame5Props={group2122Props.frame5Props}
        /> */}
        <Footer />
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="faqpm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="faqpm-group-86">
      <White src={whiteProps.src} />
      <img className="faqpm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="faqpm-white">
      <img className="faqpm-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="faqpm-icon-menu">
      <img
        className="faqpm-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="faqpm-vector-1" src={vector2} />
      <img className="faqpm-vector-1" src={vector3} />
    </div>
  );
}


function Close(props) {
  const { src } = props;

  return (
    <div className="faqpm-close">
      <img className="faqpm-vector-3" src={src} />
    </div>
  );
}


function Frame159022(props) {
  const { text119, plusProps } = props;

  return (
    <div className="faqpm-frame-159 faqpm-border-1px-black-2">
      <div className="faqpm-text faqpm-valign-text-middle faqpm-overpass-bold-shark-16px">{text119}</div>
      <Plus src={plusProps.src} />
    </div>
  );
}


function Plus(props) {
  const { src } = props;

  return (
    <div className="faqpm-plus">
      <img className="faqpm-vector-4" src={src} />
    </div>
  );
}


// function Group2122(props) {
//   const { group862Props, group872Props, group322Props, frame5Props } = props;

//   return (
//     <div className="faqpm-group-212">
//       <div className="faqpm-flex-row">
//         <Group8622 group85={group862Props.group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <Group322 {...group322Props} />
//       <Frame5
//         quickLinks={frame5Props.quickLinks}
//         frame140Props={frame5Props.frame140Props}
//         frame1402Props={frame5Props.frame1402Props}
//         frame1403Props={frame5Props.frame1403Props}
//       />
//     </div>
//   );
// }


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="faqpm-group-86-1">
      <div className="faqpm-white-1">
        <img
          className="faqpm-vector-5"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="faqpm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="faqpm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="faqpm-facebook-app-symbol">
      <img className="faqpm-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="faqpm-instagram">
      <div className="faqpm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="faqpm-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="faqpm-vector-7" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="faqpm-twitter">
      <img className="faqpm-vector-8" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="faqpm-group-32">
      <div className="faqpm-place-1 faqpm-valign-text-middle faqpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="faqpm-flex-row-1">
        <div className="faqpm-flex-col">
          <div className="faqpm-map-pin-1">
            <div className="faqpm-overlap-group1-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="faqpm-vector-9"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg"
              />
            </div>
          </div>
          <div className="faqpm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="faqpm-mail">
            <div className="faqpm-overlap-group2" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="faqpm-vector-10" src={vector2} />
            </div>
          </div>
        </div>
        <div className="faqpm-flex-col-1">
          <p className="faqpm-text-2 faqpm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="faqpm-flex-col-item faqpm-valign-text-middle faqpm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="faqpm-flex-col-item faqpm-valign-text-middle faqpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="faqpm-frame-5">
      <div className="faqpm-quick-links faqpm-valign-text-middle faqpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="faqpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`faqpm-frame-140 ${className || ""}`}>
      <div className="faqpm-about-us faqpm-valign-text-middle faqpm-typographybody16-regular">{aboutUs}</div>
      <div className="faqpm-projects faqpm-valign-text-middle faqpm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-3@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const closeData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-118@2x.svg",
};

const plusData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame159022Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plusData,
};

const plus2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590222Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plus2Data,
};

const plus3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590223Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plus3Data,
};

const plus4Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590224Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plus4Data,
};

const plus5Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590225Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plus5Data,
};

const plus6Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590226Data = {
    text119: "Lorem Ipsum passages ?",
    plusProps: plus6Data,
};

const group8622Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-17@2x.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const group322Data = {
    place: "FAQ's",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "faqpm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "faqpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

// const group2122Data = {
//     group862Props: group8622Data,
//     group872Props: group872Data,
//     group322Props: group322Data,
//     frame5Props: frame5Data,
// };

const x11FAQsPageMobileData = {
    place: "FAQ's",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-4@2x.png",
    rectangle77: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-77@2x.png",
    text117: "Lorem Ipsum passages ?",
    text118: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    frame145Props: frame145Data,
    closeProps: closeData,
    frame15902Props: frame159022Data,
    frame159022Props: frame1590222Data,
    frame159023Props: frame1590223Data,
    frame159024Props: frame1590224Data,
    frame159025Props: frame1590225Data,
    frame159026Props: frame1590226Data,
    //group2122Props: group2122Data,
};

